import { graphql } from '@/generated';

export const assignedDevicesToSiteMutation = graphql(`
  mutation assignedDevicesToSite(
    $siteId: uuid!
    $deviceIds: [uuid!]!
    $auditLogInput: AuditLogInsertInput!
  ) {
    updateDeviceMany(
      updates: { _set: { siteId: $siteId }, where: { id: { _in: $deviceIds } } }
    ) {
      affectedRows
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const unassignedDevicesFromSiteMutation = graphql(`
  mutation unassignedDevicesFromSite(
    $deviceIds: [uuid!]!
    $auditLogInput: AuditLogInsertInput!
  ) {
    updateDeviceMany(
      updates: { _set: { siteId: null }, where: { id: { _in: $deviceIds } } }
    ) {
      affectedRows
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const updateSiteMutation = graphql(`
  mutation updateSite(
    $pkColumnInput: SitePkColumnsInput!
    $setInput: SiteSetInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    updateSiteByPk(pkColumns: $pkColumnInput, _set: $setInput) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const deleteSiteMutation = graphql(`
  mutation deleteSite($id: uuid!, $auditLogInput: AuditLogInsertInput!) {
    deleteSiteByPk(id: $id) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);
